import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { NAVIGATION } from '../Navigation/Navigation.gql';
import Navigation from '../Navigation/Navigation';
import Search from '../Search/Search';

import * as Styled from './Header.styled';

/**
 * Header component that renders the Alertbar and determines whether Navigation or Search is rendered
 */
const Header = ({ sections, withSearch }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <Styled.Header>
      {!isSearchOpen ? (
        <Navigation
          sections={sections}
          withSearch={withSearch}
          onRequestOpen={() => setIsSearchOpen(true)}
        />
      ) : (
        <Search onRequestClose={() => setIsSearchOpen(false)} />
      )}
    </Styled.Header>
  );
};

Header.propTypes = {
  /**
   * Array of Navigation Level 1 Sections
   */
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      url: PropTypes.string,
      text: PropTypes.string,
      name: PropTypes.string,
      sections: PropTypes.arrayOf(PropTypes.shape({}))
    })
  ),
  /**
   * Hides the search button if false
   */
  withSearch: PropTypes.bool
};

Header.defaultProps = {
  sections: [],
  withSearch: true
};

const HeaderWithData = ({ withSearch }) => {
  const { data } = useQuery(NAVIGATION);
  const sections = data?.navigationV1?.sections;

  return <Header sections={sections} withSearch={withSearch} />;
};

HeaderWithData.propTypes = {
  /**
   * Hides the search button if false
   */
  withSearch: PropTypes.bool
};

HeaderWithData.defaultProps = {
  withSearch: true
};

export { Header };
export default HeaderWithData;
